import { styled } from '@tools/wr-catalog-base'

export const UserTrigger = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #fff;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }

  .user-icon,
  .arrow-icon {
    vertical-align: middle;
  }

  .user-icon {
    margin-right: 5px;
  }

  .arrow-icon {
    margin-right: 5px;
  }
`

export const DropdownContainer = styled.div`
  display: inline-block;

  button:focus {
    outline: none;
  }

  @media only screen and (max-width: 992px) {
    margin-left: 0;
    padding: 20px 0;
  }
`

export const PTCCatalog = styled.div`
  button {
    box-shadow: none;
    outline: none;
  }

  .navbar-container {
    overflow: visible;
  }

  .navbar-container a {
    color: #333;
  }

  .navbar-container a img {
    height: 120px;
    margin-top: -43px;

    @media only screen and (max-width: 768px) {
      padding: 0 10px;
    }
  }

  .navbar-container a:hover,
  .dropdown-trigger > div:hover,
  .dropdown-trigger > div:hover svg {
    opacity: 1;
    color: #0696d7;
  }

  .dropdown-trigger > div,
  .dropdown-trigger > div:hover,
  .dropdown-trigger > div svg,
  .dropdown-trigger > div:hover svg {
    transition: 0.2s linear color;
  }

  .hero h2 {
    font-size: 42px;
  }

  .hero h3 {
    font-size: 22px;
    margin: 0;
  }

  @media only screen and (max-width: 768px) {
    .desktop-menu a {
      padding: 0 10px;
    }
  }

  .mobile-menu {
    display: none;
  }

  .mobile-menu-list {
    margin-top: 65px;
  }

  .mobile-menu-list a,
  .mobile-menu-list .dropdown-trigger > div,
  .mobile-menu-list .dropdown-trigger svg {
    transition: opacity 0.2s;
    color: #021a32;
  }

  .mobile-menu-list a:hover,
  .mobile-menu-list .dropdown-trigger:hover {
    transition: opacity 0.2s;
    opacity: 0.7;
    color: #021a32;
  }

  .mobile-menu-list a + div,
  .mobile-menu-list a + div + div {
    display: block;
  }

  .mobile-menu-list .dropdown-trigger:hover svg {
    color: #021a32;
  }

  .dropdown-list {
    width: 200px;
    right: 0;
  }

  .nav-products {
    width: 300px;
  }

  footer {
    margin-top: 50px;
  }
`
